import ImageCardWithCenteredContents, {
  ImageCardWithCenteredContentsProps,
} from './ImageCardWithCenteredContents';

export default ImageCardWithCenteredContents;
export type { ImageCardWithCenteredContentsProps };
